import { render, staticRenderFns } from "./PuzzleGrid.vue?vue&type=template&id=63cb91c2"
import script from "./PuzzleGrid.vue?vue&type=script&lang=js"
export * from "./PuzzleGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports